import React from 'react';
export function TeamSection() {
  const managementTeam = [{
    name: 'DJ Panfili',
    role: 'Co-Founder & Managing Partner',
    bio: "DJ has spent his career building and scaling businesses across multiple industries through strategic growth initiatives and operational excellence. He has been a key strategist and advisor to private equity firms, family offices, and holding companies in the lower-middle market. He currently oversees acquisition strategies and portfolio optimization for Laundry Investors' Florida operations. His daily mission is to provide the highest quality of service and generate value for customers, business owners, and the team around him.",
    image: 'https://cdn.magicpatterns.com/uploads/vcYGxirqmyjDfwYt4Ado1p/DJ_Headshot_5.png'
  }, {
    name: 'Ciaran Houlihan',
    role: 'Co-Founder & COO',
    bio: 'Ciaran is an operations strategist and growth advisor who has built scalable systems across multiple business verticals. As COO and co-founder of Laundry Investors, he specializes in operational excellence, technology integration, and building repeatable processes that drive efficiency. With deep expertise in systems design, performance optimization, and strategic execution, Ciaran focuses on transforming operations from fragmented to streamlined, ensuring consistent quality and customer experience across the portfolio.',
    image: 'https://cdn.magicpatterns.com/uploads/jjwQQ6H84U1tz4XrTEuKeK/T03D4H6ML6P-U03CXTEHHV4-c994b4ed1992-512.png'
  }];
  const advisoryBoard = [{
    name: 'Elliot Martinez',
    role: 'Investor Relations & Strategy',
    bio: 'Elliot has been a strategic partner with over $250M in transactions in the private sector. Having started his career in commercial real estate, he attributes his personal and professional growth to the dynamic nature of each deal, the people involved, and the value created. He has a passion for bringing the right people together for a greater purpose and industry impact. Developing leaders and serving others each day are what drives him each day. People > Profits',
    image: 'https://cdn.magicpatterns.com/uploads/8Gp3nAKmSdshkWp12XWDs1/thumb_Elliiot_Headshot.jpg'
  }];
  return <div className="bg-[#0f2424]" data-id="element-217">
      {/* Management Team Section */}
      <section className="py-16 sm:py-20 lg:py-24" data-id="element-218">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-219">
          <div className="text-center mb-12 sm:mb-16" data-id="element-220">
            <h2 className="text-xs sm:text-sm font-semibold text-[#4fd1c5] tracking-widest uppercase mb-3 sm:mb-4" data-id="element-221">
              Our Team
            </h2>
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6" data-id="element-222">
              Management Team
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 max-w-5xl mx-auto" data-id="element-223">
            {managementTeam.map((member, index) => <div key={index} className="text-center" data-id="element-224">
                <div className="mb-6" data-id="element-225">
                  <img src={member.image} alt={member.name} className="w-36 h-36 sm:w-48 sm:h-48 rounded-full object-cover object-center mx-auto border-4 border-[#1a3a3a]" data-id="element-226" />
                </div>
                <h4 className="text-xl sm:text-2xl font-bold text-white mb-2" data-id="element-227">
                  {member.name}
                </h4>
                <p className="text-[#4fd1c5] font-medium mb-4 text-sm sm:text-base" data-id="element-228">
                  {member.role}
                </p>
                <p className="text-sm sm:text-base text-gray-400 leading-relaxed max-w-md mx-auto px-4 sm:px-0" data-id="element-229">
                  {member.bio}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Advisory Board Section */}
      <section className="py-16 sm:py-20 lg:py-24 bg-[#0b1a1a]" data-id="element-230">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-231">
          <div className="text-center mb-12 sm:mb-16" data-id="element-232">
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6" data-id="element-233">
              Advisory Board
            </h3>
          </div>

          <div className="max-w-4xl mx-auto" data-id="element-234">
            {advisoryBoard.map((member, index) => <div key={index} className="flex flex-col md:flex-row gap-6 sm:gap-8 items-center md:items-start" data-id="element-235">
                <div className="flex-shrink-0" data-id="element-236">
                  <img src={member.image} alt={member.name} className="w-48 h-48 sm:w-56 sm:h-56 md:w-64 md:h-64 rounded-lg object-cover object-center border-4 border-[#1a3a3a]" data-id="element-237" />
                </div>
                <div className="flex-1 text-center md:text-left" data-id="element-238">
                  <h4 className="text-2xl sm:text-3xl font-bold text-white mb-2" data-id="element-239">
                    {member.name}
                  </h4>
                  <p className="text-[#4fd1c5] font-medium mb-4 sm:mb-6 text-base sm:text-lg" data-id="element-240">
                    {member.role}
                  </p>
                  <p className="text-sm sm:text-base lg:text-lg text-gray-400 leading-relaxed px-4 md:px-0" data-id="element-241">
                    {member.bio}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}